import React, { useContext, useState } from "react";
import { Form, Input, Select, Divider, Typography } from 'antd';
import { useQuery } from "react-query";
import '../styles/styleForm.css';
import DropCountry from "./dropCountry";
import { getPaymentMethodsByCountry } from "../services/paymentApi";
import { PaymentContext } from "../../../common/PaymentContext";

const { Option } = Select;
const { Title } = Typography;

const WalletForm = () => {
    const { setPhoneNumber } = useContext(PaymentContext);
    const [phoneNumberInput, setPhoneNumberInput] = useState();
    const [prefix, setPrefix] = useState('+221');
    const [selectedCountry, setSelectedCountry] = useState('Sénégal');

    const currentuser = JSON.parse(sessionStorage.getItem('authUser'));
    const merchandId = currentuser?.user?.id;

    setPhoneNumber(prefix + phoneNumberInput);

    const prefixSelector = (
        <Form.Item name="prefix" noStyle>
            <Select
                style={{
                    width: 80,
                }}
                value={prefix}
                onChange={(value) => {
                    switch (value) {
                        case '+221':
                            setSelectedCountry('Sénégal');
                            break;
                        case '+223':
                            setSelectedCountry('Mali');
                            break;
                        case '+225':
                            setSelectedCountry('Côte d\'Ivoire');
                            break;
                        case '+226':
                            setSelectedCountry("Burkina Faso");
                            break;
                        case '+227':
                            setSelectedCountry("Niger");
                            break;
                        case '+228':
                            setSelectedCountry("Togo");
                            break;
                        case '+229':
                            setSelectedCountry("Bénin");
                            break;
                        case '+245':
                            setSelectedCountry("Guinée-Bissau");
                            break;
                    }
                    setPrefix(value)
                }}
            >
                <Option value="+221">+221</Option>
                <Option value="+223">+223</Option>
                <Option value="+225">+225</Option>
                <Option value="+226">+226</Option>
                <Option value="+227">+227</Option>
                <Option value="+228">+228</Option>
                <Option value="+229">+229</Option>
                <Option value="+245">+245</Option>
            </Select>
        </Form.Item>
    );

    const { isLoadingPaymentMethod, isErrorPaymentMethod, errorOPaymentMethod, data: paymentMethods } = useQuery(
        ["paymentMethods", merchandId],
        () => getPaymentMethodsByCountry(),
        {
            enabled: !!merchandId,
        }
    );

    return (
        <div className="containerForm">
            <Form initialValues={{ prefix: '+221' }}>
                <Form.Item
                    name="phone"
                    label="Numéro de téléphone"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your phone number!',
                        },
                    ]}
                    style={{
                        display: 'flex',
                        justifyContent: 'center',

                    }}
                >
                    <Input
                        addonBefore={prefixSelector}
                        style={{
                            width: '100%',
                        }}
                        onChange={(e) => setPhoneNumberInput(e.target.value)}
                    />
                </Form.Item>
            </Form>
            <div>
                <Divider orientation="left" plain>
                    <Title level={4}> Méthodes de paiement </Title>
                </Divider>
                <div className="row g-4">
                    {
                        paymentMethods.map((item, i) => {
                            return <div className="col-3"><DropCountry countryName={item.country} paymentMethods={item.paymentMethods} selectedCountry={selectedCountry} /></div>
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default WalletForm;